export const es = {
  // Header Navigation
  nav: {
    home: "INICIO",
    company: "XIAMEN TOWER TECH",
    sourcing: "EXPORTACIÓN",
    otherServices: "OTROS SERVICIOS",
    projects: "PROYECTOS",
    blog: "BLOG",
    partners: "Socios",
    contact: "CONTACTO"
  },
  
  // Hero Section
  hero: {
    title: "Exportación sin riesgos",
    titleHighlight: "sin riesgos",
    subtitle: "DESDE CHINA",
    description1: "De la fábrica a su almacén,",
    description1Highlight: "sin sorpresas.",
    description2: "Supervisamos cada etapa para que su negocio crezca",
    description2Highlight: "con total tranquilidad.",
    startSourcing: "Comenzar ahora",
    learnMore: "Más información"
  },

  // About Section
  about: {
    title: "Acerca de Xiamen Tower Technology Co., Ltd.",
    description: "Fundada en 2019, Xiamen Tower Technology Co., Ltd. es una empresa líder en importación, exportación y gestión de compras internacionales con sede en la Provincia de Fujian, China. Nos especializamos en conectar empresas internacionales con fabricantes chinos de confianza, garantizando calidad, eficiencia y gestión integral de la cadena de suministro.",
    feature1Title: "Equipo Multilingüe",
    feature1Description: "Hablamos inglés, alemán, español, esloveno y serbio, garantizando una comunicación clara durante todo el proceso.",
    feature2Title: "Soporte de Entrega Global",
    feature2Description: "Asistimos a clientes en todo el mundo con envíos fluidos, logística y soluciones integrales de entrega.",
    feature3Title: "Red de Fabricantes Verificados",
    feature3Description: "Colaboramos únicamente con proveedores auditados y de confianza para asegurar calidad y consistencia."
  },

  // Services Section
  services: {
    title: "Nuestros Servicios",
    description: "Ofrecemos soluciones integrales para sus necesidades de exportación y producción en China.",
    subtitle: "Podemos ayudarle en una o más etapas del proceso",
    mainTitle: "Servicios",
    sourcingTitle: "Exportación",
    otherServicesTitle: "Otros Servicios",
    sourcingDescription1: "Nos encargamos de todo el proceso de adquisición y exportación, desde la búsqueda del proveedor ideal hasta los controles de calidad y la logística optimizada.",
    sourcingDescription2: "Más que un simple intermediario, somos su socio estratégico en exportación global, garantizando eficiencia, ahorro y seguridad en cada operación.",
    otherServicesDescription1: "Ofrecemos una amplia gama de servicios complementarios de comercio internacional y gestión de compras que le permiten abordar sus proyectos de internacionalización con total confianza.",
    otherServicesDescription2: "Desde consultoría estratégica hasta acceso a nuevos mercados, nuestro equipo actúa como un verdadero socio en el crecimiento global de su empresa.",
    hideDetails: "Ocultar Detalles",
    showInfo: "+ MÁS INFO",
    moreInfo: "Más Información",
    process: "Nuestro Proceso",
    benefits: "Beneficios Clave",
    supplierSelection: {
      title: "Selección de Proveedores",
      description: "Identificamos y validamos fabricantes confiables en China que cumplen con sus requisitos específicos y estándares de calidad.",
      steps: {
        step1: "Análisis de requisitos e investigación de mercado",
        step2: "Identificación y preselección de proveedores calificados",
        step3: "Visitas a fábricas y evaluaciones técnicas",
        step4: "Verificación y certificación de proveedores"
      },
      benefits: {
        benefit1: "Acceso a fabricantes premium verificados",
        benefit2: "Riesgos minimizados mediante rigurosa evaluación",
        benefit3: "Reducción del tiempo de calificación de proveedores"
      }
    },
    productDevelopment: {
      title: "Desarrollo de Productos",
      description: "Transformamos su idea en un producto viable y de alta calidad — desde el concepto hasta la producción en serie — garantizando los más altos estándares.",
      steps: {
        step1: "Especificaciones técnicas y requisitos de diseño",
        step2: "Creación de prototipos y muestras",
        step3: "Optimización técnica y análisis de costos",
        step4: "Preparación de producción y desarrollo de herramientas"
      },
      benefits: {
        benefit1: "Diseño enfocado en la fabricabilidad y escalabilidad",
        benefit2: "Menor tiempo de lanzamiento al mercado",
        benefit3: "Mejora continua basada en retroalimentación del mercado"
      }
    },
    qualityControl: {
      title: "Control de Calidad",
      description: "Supervisamos cada etapa de la producción para garantizar cumplimiento, consistencia y excelencia en todos los lotes fabricados.",
      steps: {
        step1: "Inspección de materiales y controles previos a la producción",
        step2: "Monitoreo durante la producción (DUPRO)",
        step3: "Inspección final antes del envío (PSI)",
        step4: "Informes detallados con documentación fotográfica"
      },
      benefits: {
        benefit1: "Detección temprana de problemas de calidad",
        benefit2: "Menor tasa de devoluciones y reclamos",
        benefit3: "Nivel de calidad constante en todos los lotes"
      }
    },
    logisticsManagement: {
      title: "Gestión Logística",
      description: "Coordinamos toda la cadena de suministro para importaciones eficientes y exitosas desde China hasta su almacén.",
      steps: {
        step1: "Selección y negociación con socios logísticos",
        step2: "Despacho aduanal y documentación de exportación",
        step3: "Consolidación de contenedores y optimización del envío",
        step4: "Seguimiento en tiempo real hasta la entrega final"
      },
      benefits: {
        benefit1: "Costos de envío optimizados mediante rutas inteligentes",
        benefit2: "Entregas más rápidas con opciones exprés",
        benefit3: "Seguro completo y protección de carga"
      }
    }
  },

  // Service Process & Additional Services
  serviceProcess: {
    title: "Nuestro Proceso:",
    steps: [
      "Investigación de mercado e identificación de proveedores calificados",
      "Negociación de precios y condiciones contractuales",
      "Control de calidad y gestión de cronogramas de producción",
      "Coordinación logística integral de extremo a extremo"
    ]
  },

  additionalServices: {
    title: "Servicios Adicionales:",
    items: [
      "Consultoría de entrada al mercado",
      "Soporte de personalización de productos", 
      "Asistencia de cumplimiento regulatorio",
      "Desarrollo de asociaciones a largo plazo"
    ]
  },

  // Service Details (for expanded info sections)
  serviceDetails: {
    supplierSelection: {
      fullDescription: "Nuestro proceso integral de selección de proveedores incluye verificaciones detalladas de antecedentes, auditorías de fábrica, revisión de certificaciones de calidad y evaluaciones de capacidad de producción. Verificamos licencias comerciales, certificaciones de exportación y referencias de clientes anteriores para asegurar asociaciones con fabricantes confiables.",
      benefits: [
        "Verificación y auditorías de fábrica",
        "Verificaciones de certificación de calidad", 
        "Evaluación de capacidad de producción",
        "Evaluación de estabilidad financiera",
        "Validación de referencias de clientes anteriores"
      ]
    },
    productDevelopment: {
      fullDescription: "Desde el concepto hasta la producción, acompañamos todo su proceso de desarrollo de producto. Nuestro equipo colabora con fabricantes para crear prototipos, optimizar diseños, realizar pruebas y garantizar que su producto cumpla con los estándares internacionales antes del inicio de la producción en serie.",
      benefits: [
        "Desarrollo de prototipos",
        "Optimización de diseño",
        "Pruebas y validación de calidad", 
        "Cumplimiento de estándares internacionales",
        "Planificación de cronograma de producción"
      ]
    },
    qualityControl: {
      fullDescription: "Nuestro equipo de control de calidad realiza inspecciones previas a la producción, seguimiento durante el proceso e inspecciones finales del producto. Aplicamos estándares internacionales de calidad y proporcionamos informes detallados con fotografías para garantizar que sus productos cumplan con todas las especificaciones.",
      benefits: [
        "Inspecciones previas a la producción",
        "Monitoreo de calidad durante el proceso",
        "Inspección final del producto",
        "Informes detallados de calidad", 
        "Cumplimiento de estándares internacionales"
      ]
    },
    logisticsManagement: {
      fullDescription: "Gestionamos toda la cadena logística, desde la recogida en fábrica hasta la entrega final en su almacén. Esto incluye documentación de exportación, despacho aduanero, coordinación de envíos, cobertura de seguro y seguimiento en tiempo real durante todo el trayecto.",
      benefits: [
        "Manejo de documentación de exportación",
        "Asistencia de despacho aduanero",
        "Coordinación de envío y flete",
        "Cobertura de seguro",
        "Seguimiento de envío en tiempo real"
      ]
    }
  },

  // Global Reach Section
  globalReach: {
    title: "Alcance Global",
    description: "Con nuestra sólida red de proveedores y experiencia local en China, apoyamos a clientes de todo el mundo con abastecimiento confiable, inspecciones de calidad y coordinación completa de proyectos en diversas industrias.",
    feature1Title: "🌍 Países Atendidos",
    feature1Description: "Apoyo a clientes en todas las principales regiones del mundo.",
    feature2Title: "🤝 Clientes Internacionales",
    feature2Description: "Confiado por empresas en Europa, América, Asia y más allá.",
    feature3Title: "🏭 Red de Proveedores Verificados",
    feature3Description: "Trabajamos exclusivamente con fabricantes auditados y confiables.",
    feature4Title: "📦 Gestión Integral de Proyectos",
    feature4Description: "Desde la selección de proveedores hasta la entrega final, coordinamos cada paso por ti."
  },

  // Projects Section
  projects: {
    title: "Categorías de Productos",
    description: "Explore nuestra amplia gama de categorías de productos y descubra las soluciones de calidad que podemos obtener para las necesidades de su negocio.",
    subtitle: "En qué trabajamos",
    viewDetails: "Ver Detalles",
    viewProducts: "Ver Productos",
    hideProducts: "Ocultar",
    contactForDetails: "Para información detallada del producto y precios, póngase en contacto con nuestro equipo a través del formulario a continuación.",
    lookingForSpecific: "¿Busca Algo Específico?",
    lookingDescription: "Nuestros expertos en exportación pueden ayudarle a encontrar los fabricantes y proveedores correctos en China para cualquier categoría de producto o requisitos personalizados que pueda tener.",
    contactTeam: "Contacte a Nuestro Equipo",
    viewAllCategories: "Ver Todas las Categorías",
    allProjects: "Todos los Proyectos",
    startYourProject: "Iniciar Su Proyecto",
    categories: {
      electronics: "ELECTRÓNICOS",
      machinery: "MAQUINARIA", 
      tools: "HERRAMIENTAS",
      packaging: "EMBALAJE",
      consumer: "BIENES DE CONSUMO",
      textiles: "TEXTILES",
      apparel: "ROPA Y PRODUCTOS PARA BEBÉS"
    }
  },

  // Products (translated from mockData)
  products: {
    electronics: {
      solarPanels: {
        name: "Sistemas de paneles solares",
        description: "Paneles monocristalinos y policristalinos de alta eficiencia"
      },
      electricBikes: {
        name: "Bicicletas y scooters eléctricos", 
        description: "E-bikes y scooters inteligentes con GPS y baterías de larga duración"
      },
      ledLights: {
        name: "Lámparas solares LED de calle",
        description: "Sistemas todo en uno con sensores y control remoto"
      },
      powerBanks: {
        name: "Baterías solares portátiles",
        description: "Estaciones de carga de alta capacidad para uso exterior o de emergencia"
      },
      smartHome: {
        name: "Dispositivos domésticos inteligentes",
        description: "Termostatos WiFi, enchufes inteligentes y control por voz"
      }
    },
    machinery: {
      cncMachining: {
        name: "Centros de mecanizado CNC",
        description: "Equipos de precisión de 3–5 ejes para producción y prototipado"
      },
      conveyor: {
        name: "Sistemas de transporte industrial", 
        description: "Cintas automatizadas para empaquetado y manipulación de materiales"
      },
      hydraulicPress: {
        name: "Prensas hidráulicas",
        description: "Máquinas para conformado de metal y aplicaciones industriales"
      },
      pneumaticTools: {
        name: "Herramientas y componentes neumáticos",
        description: "Compresores, cilindros y accesorios"
      },
      weldingEquipment: {
        name: "Equipos de soldadura",
        description: "Soldadoras MIG/TIG, cortadoras de plasma y accesorios"
      }
    },
    tools: {
      measuring: {
        name: "Instrumentos de medición de precisión",
        description: "Calibradores digitales, micrómetros e indicadores"
      },
      toolSets: {
        name: "Kits industriales de herramientas",
        description: "Juegos completos de herramientas mecánicas y eléctricas"
      },
      powerAccessories: {
        name: "Accesorios para herramientas eléctricas", 
        description: "Brocas, sierras y discos abrasivos"
      },
      handTools: {
        name: "Herramientas manuales",
        description: "Llaves, destornilladores, alicates y llaves Allen"
      },
      safetyEquipment: {
        name: "Equipo de seguridad",
        description: "Gafas, guantes, cascos y protectores auditivos"
      }
    },
    packaging: {
      packagingMachines: {
        name: "Máquinas automáticas de envasado",
        description: "Equipos para el envasado de alimentos, productos farmacéuticos y de consumo"
      },
      labelingSystems: {
        name: "Sistemas de etiquetado e impresión",
        description: "Impresoras industriales y máquinas de codificación"
      },
      sealingEquipment: {
        name: "Equipos de cierre", 
        description: "Selladoras térmicas y al vacío, dispensadores automáticos de cinta"
      },
      corrugatedBoxes: {
        name: "Cajas y cartones ondulados",
        description: "Cajas personalizadas impresas en varios tamaños"
      },
      protectivePackaging: {
        name: "Embalaje protector",
        description: "Rellenos de espuma, burbujas de aire y materiales de amortiguación"
      }
    },
    consumer: {
      smartAppliances: {
        name: "Electrodomésticos inteligentes",
        description: "Robots aspiradores, purificadores de aire y termostatos inteligentes"
      },
      furniture: {
        name: "Muebles planos",
        description: "Muebles desmontables, sillas y sistemas de almacenamiento"
      },
      kitchenGadgets: {
        name: "Utensilios de cocina", 
        description: "Freidoras de aire, hervidores, robots de cocina y herramientas innovadoras"
      },
      fitnessAccessories: {
        name: "Accesorios de fitness",
        description: "Esterillas de yoga, bandas elásticas, botellas y equipamiento deportivo"
      },
      phoneAccessories: {
        name: "Accesorios para teléfonos",
        description: "Fundas, cargadores inalámbricos, auriculares y soportes"
      }
    },
    textiles: {
      technicalFabrics: {
        name: "Tejidos técnicos",
        description: "Tejidos ignífugos, impermeables y antibacterianos para aplicaciones especiales"
      },
      sustainableClothing: {
        name: "Ropa sostenible",
        description: "Algodón orgánico, fibras de bambú y poliéster reciclado"
      },
      homeTextiles: {
        name: "Textil para el hogar",
        description: "Ropa de cama, cortinas, manteles y telas decorativas"
      },
      workwear: {
        name: "Ropa laboral y uniformes", 
        description: "Ropa profesional, chalecos de seguridad, delantales y uniformes corporativos"
      },
      cottonProducts: {
        name: "Productos de algodón",
        description: "Camisetas, toallas, calcetines y ropa de uso diario"
      }
    },
    apparel: {
      babyProducts: {
        name: "Productos y accesorios para bebés",
        description: "Ropa de bebé, pañales, biberones, cochecitos, sillas de auto y artículos de seguridad"
      },
      kidsClothing: {
        name: "Ropa y calzado infantil",
        description: "Uniformes escolares, zapatillas y colecciones de temporada"
      },
      adultsFashion: {
        name: "Moda para adultos",
        description: "Ropa casual, de oficina y deportiva, junto con accesorios de moda"
      },
      maternitywear: {
        name: "Moda premamá y lactancia", 
        description: "Ropa cómoda para el embarazo, la lactancia y el posparto"
      },
      seasonalCollections: {
        name: "Colecciones de temporada",
        description: "Ropa de invierno, verano y temática festiva para todas las edades"
      },
      footwearAccessories: {
        name: "Calzado y accesorios",
        description: "Zapatos, botas, bolsos, cinturones y bisutería"
      }
    }
  },

  // Blog Section
  blog: {
    title: "Últimas Noticias de EXPO China e Insights de la Industria",
    description: "Manténgase actualizado con las últimas tendencias, noticias e insights de la industria manufacturera y de exportación de China.",
    chinaExpoNews: "Últimas Noticias de EXPO China",
    industryInsights: "Insights de la Industria",
    industryInsightsDescription: "Tendencias del mercado, estrategias de abastecimiento y análisis que están moldeando la manufactura global.",
    dailyArticles: "Artículos Diarios",
    dailyArticlesSubtext: "Novedades y tendencias del sector, actualizadas cada día",
    readMore: "Leer Más",
    viewAllArticles: "Ver Todos los Artículos",
    lastUpdated: "Última Actualización",
    refreshAll: "Actualizar Todo",
    updating: "Actualizando...",
    autoUpdatesMonthly: "Auto-actualizaciones mensuales",
    liveFeeds: "Feeds en vivo de la industria",
    expoUpdates: "Actualizaciones de EXPO China",
    expoDescription: "Últimas noticias de CIIE, Feria de Cantón y eventos comerciales importantes"
  },

  // Contact Section
  contact: {
    title: "Contáctanos",
    description: "¿Listo para comenzar su proyecto de suministro? Póngase en contacto con nuestro equipo para soluciones personalizadas.",
    alternateTitle: "¡Mantengámonos en contacto!",
    alternateDescription: "Si tiene alguna pregunta o consulta sobre nuestros servicios, envíenos un formulario de contacto o póngase en contacto con nuestra oficina directamente.",
    fullName: "Nombre Completo",
    email: "Dirección de Email",
    company: "Empresa",
    subject: "Asunto",
    message: "Mensaje",
    yourName: "Su Nombre",
    yourEmail: "Su Email",
    companyName: "Nombre de la Empresa",
    tellUs: "Cuéntenos sobre los requisitos de su proyecto...",
    attachFiles: "Adjuntar archivos",
    filesSelected: "archivo(s) seleccionado(s)",
    acceptPrivacy: "Acepto la Política de Privacidad",
    sendMessage: "Enviar Mensaje",
    messageSent: "¡Mensaje enviado correctamente!",
    responseTime: "Le responderemos en un plazo de 24 horas.",
    validationError: "Error de validación",
    fillRequiredFields: "Por favor, rellene todos los campos obligatorios.",
    invalidEmail: "Por favor, introduzca una dirección de correo electrónico válida.",
    errorTitle: "Error",
    errorMessage: "No se pudo enviar el mensaje. Inténtelo de nuevo o contáctenos directamente en office@towertech-xm.com",
    phoneLabel: "Teléfono",
    emailLabel: "Email",
    locationLabel: "Ubicación",
    foundedLabel: "Fundada",
    ourOffice: "Nuestra Oficina",
    howHelp: "¿Cómo podemos ayudarle?",
    requirementsDetail: "Por favor explique sus requisitos con el mayor detalle posible. También puede enviarnos cualquier documentación relevante (planos, detalles), si lo desea. Todas las consultas serán procesadas y respondidas prontamente por nuestro equipo.",
    attachDocumentation: "¿Necesita adjuntar documentación de su proyecto?",
    privacyAccept: "He leído y acepto la",
    privacyPolicies: "Política de Privacidad",
    contactForm: "Envíanos un mensaje a través de nuestro formulario de contacto"
  },

  // Footer
  footer: {
    description: "Su socio de confianza para exportación sin riesgos desde China. Conectamos empresas en todo el mundo con fabricantes confiables y aseguramos calidad en cada paso.",
    quickLinks: "Enlaces Rápidos",
    home: "Inicio",
    about: "Acerca de Nosotros", 
    services: "Servicios",
    projects: "Proyectos",
    blog: "Blog",
    contact: "Contacto",
    legal: "Legal",
    termsOfService: "Términos de Servicio",
    privacyPolicy: "Política de Privacidad",
    cookiePolicy: "Política de Cookies",
    gdprCompliance: "Cumplimiento GDPR",
    languagesWeSpeak: "Idiomas que Hablamos",
    rights: "Todos los derechos reservados.",
    adminPanel: "Panel de Administración",
    scrollToTop: "Volver arriba"
  },

  // Legal Pages  
  legal: {
    goBack: "Volver",
    lastUpdated: "Última Actualización: Diciembre 2024",
    
    // Terms of Service
    terms: {
      title: "Términos de Servicio",
      section1: {
        title: "1. Aceptación de los Términos",
        content: "Al acceder y utilizar el sitio web de Xiamen Tower Technology Co., Ltd. (towertech-xm.com), usted acepta estar sujeto a estos Términos de Servicio y todas las leyes y regulaciones aplicables. Si no está de acuerdo con alguno de estos términos, tiene prohibido utilizar este sitio."
      },
      section2: {
        title: "2. Información de la Empresa",
        company: "Empresa: Xiamen Tower Technology Co., Ltd.",
        address: "Dirección: Provincia de Fujian, China",
        phone: "Teléfono: +86 15381939338", 
        email: "Correo: office@towertech-xm.com",
        founded: "Fundada: 2019",
        services: "Xiamen Tower Technology Co., Ltd. proporciona servicios de importación-exportación y suministro de productos, especializándose en conectar empresas internacionales con fabricantes chinos. Nuestros servicios incluyen:"
      },
      section3: {
        title: "3. Licencia de Uso",
        content: "Se otorga permiso para descargar temporalmente una copia de los materiales en el sitio web de Xiamen Tower Technology para visualización personal y no comercial únicamente. Esta es la concesión de una licencia, no una transferencia de título."
      },
      section4: {
        title: "4. Descargo de Responsabilidad",
        content: "Los materiales en el sitio web de Xiamen Tower Technology se proporcionan 'tal como están'. Xiamen Tower Technology no ofrece garantías, expresas o implícitas, y por la presente renuncia y niega todas las demás garantías."
      },
      section5: {
        title: "5. Limitaciones",
        content: "En ningún caso Xiamen Tower Technology o sus proveedores serán responsables de daños (incluyendo, sin limitación, daños por pérdida de datos o beneficios, o debido a interrupción del negocio) que surjan del uso o la incapacidad de usar los materiales en el sitio web de Xiamen Tower Technology."
      },
      section6: {
        title: "6. Información de Contacto",
        content: "Para cualquier pregunta sobre estos Términos de Servicio, contáctenos en office@towertech-xm.com o +86 15381939338."
      }
    },
    
    // Privacy Policy
    privacy: {
      title: "Política de Privacidad",
      section1: {
        title: "1. Información que Recopilamos",
        intro: "Xiamen Tower Technology recopila información que nos proporciona directamente, como cuando usted:",
        items: [
          "Completa nuestros formularios de contacto",
          "Solicita cotizaciones o información sobre nuestros servicios",
          "Se suscribe a nuestro boletín",
          "Se comunica con nosotros por correo electrónico o teléfono", 
          "Visita nuestro sitio web (a través de cookies y tecnologías similares)"
        ]
      },
      section2: {
        title: "2. Cómo Utilizamos su Información",
        content: "Utilizamos la información que recopilamos para proporcionar, mantener y mejorar nuestros servicios, responder a sus consultas, enviarle comunicaciones de marketing (con su consentimiento) y cumplir con las obligaciones legales."
      },
      section3: {
        title: "3. Intercambio de Información",
        content: "No vendemos, comercializamos ni transferimos su información personal a terceros sin su consentimiento, excepto como se describe en esta política o según lo requiera la ley."
      },
      section4: {
        title: "4. Seguridad de Datos",
        content: "Implementamos medidas de seguridad apropiadas para proteger su información personal contra acceso no autorizado, alteración, divulgación o destrucción."
      },
      section5: {
        title: "5. Sus Derechos",
        content: "Tiene derecho a acceder, actualizar o eliminar su información personal. También puede optar por no recibir comunicaciones de marketing de nosotros en cualquier momento."
      },
      section6: {
        title: "6. Contáctenos",
        content: "Si tiene alguna pregunta sobre esta Política de Privacidad, contáctenos en office@towertech-xm.com."
      }
    },
    
    // Cookie Policy
    cookies: {
      title: "Política de Cookies",
      section1: {
        title: "1. ¿Qué son las Cookies?",
        content: "Las cookies son pequeños archivos de texto que se almacenan en su dispositivo cuando visita nuestro sitio web. Nos ayudan a brindarle una mejor experiencia de navegación."
      },
      section2: {
        title: "2. Tipos de Cookies que Utilizamos",
        essential: "Cookies Esenciales: Necesarias para que el sitio web funcione correctamente",
        analytics: "Cookies Analíticas: Nos ayudan a entender cómo los visitantes usan nuestro sitio web",
        preferences: "Cookies de Preferencias: Recuerdan sus configuraciones y preferencias"
      },
      section3: {
        title: "3. Gestión de Cookies",
        content: "Puede controlar y gestionar las cookies a través de la configuración de su navegador. Tenga en cuenta que deshabilitar ciertas cookies puede afectar la funcionalidad del sitio web."
      }
    },
    
    // GDPR Compliance
    gdpr: {
      title: "Cumplimiento GDPR", 
      section1: {
        title: "1. Protección de Datos",
        content: "Xiamen Tower Technology está comprometida con la protección de sus datos personales de acuerdo con el Reglamento General de Protección de Datos (GDPR)."
      },
      section2: {
        title: "2. Sus Derechos Bajo GDPR",
        rights: [
          "Derecho a acceder a sus datos personales",
          "Derecho a la rectificación de datos inexactos",
          "Derecho al borrado de sus datos", 
          "Derecho a restringir el procesamiento",
          "Derecho a la portabilidad de datos",
          "Derecho a oponerse al procesamiento"
        ]
      },
      section3: {
        title: "3. Contacte a Nuestro Oficial de Protección de Datos",
        content: "Para cualquier consulta relacionada con GDPR, contáctenos a office@towertech-xm.com."
      }
    }
  },

  // FAQ Section
  faq: {
    title: "Preguntas Frecuentes",
    subtitle: "Todo lo que necesita saber para exportar con éxito",
    takeAdvantage: "Aproveche las ventajas de la exportación internacional sin riesgos",
    helpOptimize: "Le ayudamos a optimizar costos y minimizar riesgos en sus exportaciones.",
    successfulImporting: "La exportación exitosa comienza con expertos y procesos rigurosos.",
    startProject: "Iniciar Su Proyecto",
    questions: [
      {
        question: "¿En qué regiones operan?",
        answer: "Estamos basados en China y atendemos a clientes de todo el mundo con servicios de abastecimiento, gestión de proveedores, control de calidad y entregas internacionales desde China."
      },
      {
        question: "¿Ofrecen servicios de desarrollo de productos personalizados?",
        answer: "Sí, proporcionamos servicios integrales de desarrollo desde el concepto hasta la producción final. Supervisamos cada etapa del proceso para asegurar que su producto cumpla con todas las especificaciones técnicas y estándares de calidad requeridos."
      },
      {
        question: "¿Cómo garantizan la calidad de los productos?",
        answer: "Implementamos un sistema integral de auditorías de fábrica y control de calidad, verificando que cada lote de producción cumpla estrictamente con los estándares acordados. Nuestro equipo de inspección de calidad opera permanentemente en China para supervisión en tiempo real."
      },
      {
        question: "¿Proporcionan gestión de envío y logística?",
        answer: "Coordinamos toda la cadena logística en colaboración con proveedores y agentes de carga, asegurando el transporte eficiente desde las fábricas chinas hasta su almacén, gestionando despacho aduanero, documentación y coordinación de entrega."
      }
    ]
  },

  // Languages
  languages: {
    en: "English",
    es: "Español",
    de: "Deutsch", 
    sl: "Slovenščina",
    sr: "Српски"
  },

  // Common UI Elements
  ui: {
    backButton: "Volver",
    loading: "Cargando...",
    error: "Error",
    success: "Éxito",
    close: "Cerrar",
    save: "Guardar",
    cancel: "Cancelar",
    delete: "Eliminar",
    edit: "Editar",
    view: "Ver",
    hide: "Ocultar",
    show: "Mostrar",
    more: "Más",
    less: "Menos",
    keyBenefits: "Beneficios Clave:"
  },

  // Cookie Consent Banner
  cookies: {
    bannerTitle: "Usamos cookies",
    bannerDescription: "Utilizamos cookies para mejorar su experiencia de navegación, analizar el tráfico del sitio y personalizar el contenido. Al hacer clic en \"Aceptar todo\", usted acepta el uso de cookies.",
    acceptAll: "Aceptar todo",
    declineOptional: "Rechazar opcionales"
  },

  // Socios Internacionales
  partners: {
    title: "Nuestros Socios Internacionales",
    subtitle: "Colaboradores de confianza que amplían nuestro alcance y respaldan a clientes en mercados globales clave.",
    websiteLabel: "Sitio web",
    becomePartner: "¿Le interesa convertirse en socio oficial de distribución?",
    contactCta: "Contáctenos",
    valsol: {
      tagline: "Socio de Distribución en Chile",
      description: "Socio oficial de Xiamen Tower Technology Co., Ltd. en Chile.\nEspecializado en aprovisionamiento directo e importaciones desde China, apoyando a clientes locales con soluciones confiables de cadena de suministro y coordinación en el mercado."
    }
  }
};